import { IconContent } from '@icons';

export const tasks: IconContent = {
    md: '<g fill-rule="evenodd" clip-rule="evenodd"><path d="M7.5 6H4v14h16V6h-3.5v2h-1V6h-7v2h-1V6Zm1-1h7V3h1v2H21v16H3V5h4.5V3h1v2Z"/><path d="M13 13h5v1h-5v-1ZM13 15h5v1h-5v-1ZM13 17h5v1h-5v-1ZM21 10.5H3v-1h18v1ZM11.2 13.9l-3.4 3.4-2.2-2 .8-.8L7.8 16l2.7-2.8.7.8Z"/></g>',
};
